"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.msalConstants = void 0;
let redirectUri = window.location.origin;
if (window.localStorage.getItem('appName') === null || window.localStorage.getItem('appName') === undefined) {
  window.localStorage.setItem('appName', '');
}
const msalConstants = exports.msalConstants = {
  portalApplicationConfig: {
    clientID: '',
    // IAM Portal (Prod)
    scopes: ['openid'],
    authority: 'https://login.microsoftonline.com/72ca17d4-d1db-496b-8e11-2617ae372f4f'
  },
  apiApplicationConfig: {
    clientID: '',
    // Apis-Production-AppRegistration
    scopes: [''],
    authority: 'https://login.microsoftonline.com/72ca17d4-d1db-496b-8e11-2617ae372f4f'
  },
  redirectUri: redirectUri
};